
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiAisTargetActivatedNohdgcogSelectedIec as ObiAisTargetActivatedNohdgcogSelectedIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-ais-target-activated-nohdgcog-selected-iec.js';
 
 
 

 
 export const ObiAisTargetActivatedNohdgcogSelectedIec = createComponent({
   react: React,
   tagName: 'obi-ais-target-activated-nohdgcog-selected-iec',
   elementClass: ObiAisTargetActivatedNohdgcogSelectedIecElement,
   events: {
     
   }
  });
 
 